import actions from "./actions";

const { FETCH_SANDWICHES, RESET_SANDWICH } = actions;

const initState = {
    sandwiches: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
};

const SandwichReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_SANDWICHES:
            return {
                ...state,
                sandwiches: data
            };

        case RESET_SANDWICH:
            return {
                ...state,
                sandwiches: initState.sandwiches,
            };

        default:
            return state;
    }
};

export default SandwichReducer;
